import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DipendentiPort } from './dipendenti.port';
import {
  Utente,
  CreateDipendenteDto,
  DipendentiQueryParams,
  DipendentiPage,
  UpdateDatiAziendaDto, DatiAziendaDto
} from '../../models/utente.mdoel';
import { environment } from '../../../environments/environment';
import {TenantService} from '../tenant.service';

@Injectable({ providedIn: 'root' })
export class DipendentiHttpService implements DipendentiPort {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);
  private base = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/dipendenti`;

  getListPaginated(params: DipendentiQueryParams): Observable<DipendentiPage> {
    let httpParams = new HttpParams()
      .set('page', String(params.page ?? 0))
      .set('size', String(params.size ?? 20));
    if (params.denominazioneSearch) httpParams = httpParams.set('denominazioneSearch', params.denominazioneSearch);
    if (params.sort) params.sort.forEach(s => { httpParams = httpParams.append('sort', s); });
    return this.http.get<any>(this.base, { params: httpParams }).pipe(
      map((res: any) => ({
        content: res?.content ?? [],
        totalElements: res?.totalElements ?? 0,
        totalPages: res?.totalPages ?? 0,
        pageIndex: res?.pageIndex ?? params.page ?? 0,
      }))
    );
  }

  getById(id: number): Observable<Utente> {
    return this.http.get<Utente>(`${this.base}/${id}`);
  }

  create(dto: CreateDipendenteDto): Observable<void> {
    return this.http.post<void>(this.base, dto);
  }

  update(id: number, dto: CreateDipendenteDto): Observable<void> {
    return this.http.put<void>(`${this.base}/${id}`, dto);
  }

  archive(id: number, archive: boolean): Observable<void> {
    const params = new HttpParams().set('archive', String(archive));

    return this.http.patch<void>(
      `${this.base}/${id}/archive`,
      null,
      { params }
    );
  }

  private datiAziendeBase =
    `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/datiAziende`;

  getDatiAzienda(id: number): Observable<DatiAziendaDto> {
    return this.http.get<DatiAziendaDto>(
      `${this.datiAziendeBase}/${id}`
    );
  }

  updateDatiAzienda(
    id: number,
    dto: UpdateDatiAziendaDto
  ): Observable<number> {
    return this.http.patch<number>(
      `${this.datiAziendeBase}/${id}`,
      dto
    );
  }

  uploadLogoDatiAzienda(
    id: number,
    file: File
  ): Observable<number> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<number>(
      `${this.datiAziendeBase}/${id}/logo`,
      formData
    );
  }
}
